/**
 * Search -> Product universe.
 *
 * The "Search" links of the header used to open a small search drawer. They now take the visitor to the product
 * universe (templates/search.universe.json), which has its own search box. Real searches (/search?q=...) are left
 * alone and keep showing the usual results page.
 *
 *  - click on a header search link      -> goes to <search page>?view=universe (or, if the universe is already
 *                                          on screen, just puts the cursor in its search box)
 *  - opening the bare search page       -> switches to the universe (covers "open in a new tab" and old bookmarks)
 *  - skipped in the theme editor, so the search drawer can still be edited there.
 *
 * To go back to the search drawer, delete this file and its <script> tag in layout/theme.liquid.
 */
(function () {
  'use strict';

  var inEditor = window.Shopify && window.Shopify.designMode;

  if (inEditor) {
    return;
  }

  // Bare search page (no query, no view chosen): show the universe instead. Handles a locale prefix like /en/search.
  if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/search\/?$/i.test(window.location.pathname) && !window.location.search) {
    window.location.replace(window.location.pathname + '?view=universe');
    return;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var trigger = event.target.closest && event.target.closest('[aria-controls="search-drawer"]');

      if (!trigger) {
        return;
      }

      // Runs before the theme's own handler (capture phase) and keeps it from opening the drawer
      event.preventDefault();
      event.stopImmediatePropagation();

      var field = document.querySelector('.pu__search input');

      if (field) {
        field.focus();
        return;
      }

      var base = (trigger.getAttribute('href') || '/search').split('?')[0];
      window.location.assign(base + '?view=universe');
    },
    true
  );
})();
